import React, { useEffect, useMemo, useState } from 'react';
import { isPlatform } from '@ionic/react';
import { StyledBackdrop, StyledNeedUpdateModal } from './NeedUpdateModal.styled';
import {
  needUpdateNativeButtonHandler,
  needUpdateNativeFocusHandler,
  needUpdateWebButtonHandler,
  needUpdateWebFocusHandler,
} from './utils';
import { useIntl } from 'react-intl';
import { useDispatch } from 'react-redux';
import { Toast } from '@mindly/ui-components';

//
const NeedUpdateModal: React.FC = () => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const [updateModalStatus, setUpdateModalStatus] = useState<'' | 'show_on_native' | 'show_on_web'>('');

  const isShowOnWeb = useMemo(() => updateModalStatus === 'show_on_web', [updateModalStatus]);

  const updateButtonHandler = () => {
    return isShowOnWeb ? needUpdateWebButtonHandler : needUpdateNativeButtonHandler;
  };

  const onFocusHandler = useMemo(
    () =>
      isPlatform('hybrid')
        ? needUpdateNativeFocusHandler(setUpdateModalStatus)
        : needUpdateWebFocusHandler(setUpdateModalStatus, dispatch),
    [updateModalStatus]
  );

  useEffect(() => {
    if (isPlatform('hybrid')) {
      needUpdateNativeFocusHandler(setUpdateModalStatus)();
    } else {
      window.addEventListener('focus', onFocusHandler);
    }
    return () => {
      !isPlatform('hybrid') && window.removeEventListener('focus', onFocusHandler);
    };
  }, []);
  return (
    <>
      {!!updateModalStatus.length && <StyledBackdrop />}
      <StyledNeedUpdateModal isOpen={!!updateModalStatus.length} backdropDismiss={false}>
        <Toast
          position={'bottom'}
          positionOffset={16}
          heading={intl.formatMessage({
            id: 'need_update_modal__heading',
            defaultMessage: 'Доступна нова версія',
          })}
          text={intl.formatMessage({
            id: 'need_update_modal__text',
            defaultMessage: 'Ви повинні оновити додаток, щоб встановити останню версію.',
          })}
          buttons={[
            {
              text: intl.formatMessage({
                id: 'general.refresh',
                defaultMessage: 'Оновити',
              }),
              handler: updateButtonHandler(),
              type: 'filled',
            },
          ]}
        />
      </StyledNeedUpdateModal>
    </>
  );
};

export default NeedUpdateModal;
